import { defineNuxtPlugin } from '#app/nuxt'
import { LazyContentBlockAbout, LazyContentBlockAboutItem, LazyContentBlockAutomatedStock, LazyContentBlockAutomatedStockChart, LazyContentBlockBanner, LazyContentBlockCenteredText, LazyContentBlockCommitteeSection, LazyContentBlockContacts, LazyContentBlockCtaBanner, LazyContentBlockDocuments, LazyContentBlockEmbedDocument, LazyContentBlockEvents, LazyContentBlockEventsAlternative, LazyContentBlockFaqByTopics, LazyContentBlockFinancials, LazyContentBlockHero, LazyContentBlockHeroAlternative, LazyContentBlockImage, LazyContentBlockImageWithList, LazyContentBlockImageWithListItem, LazyContentBlockKaleidoscopePressReleases, LazyContentBlockLeadership, LazyContentBlockLinks, LazyContentBlockNumbersList, LazyContentBlockNumbersListItem, LazyContentBlockPageTitle, LazyContentBlockParagraph, LazyContentBlockPressReleases, LazyContentBlockPressReleasesAlternative, LazyContentBlockPromoBanner, LazyContentBlockQuote, LazyContentBlockReports, LazyContentBlockResources, LazyContentBlockResourcesAlternative, LazyContentBlockShortBanner, LazyContentBlockStock, LazyContentBlockTeamGrid, LazyContentBlockTeamGridItem, LazyContentBlockTeamSlider, LazyContentBlockTeamSliderItem, LazyContentBlockTextWithImage, LazyContentBlockTiles, LazyContentBlockTwoColumnsText, LazyContentBlockVideosTimeline, LazyContentBlockVideosTimelineElement, LazyIcon } from '#components'
const lazyGlobalComponents = [
  ["ContentBlockAbout", LazyContentBlockAbout],
["ContentBlockAboutItem", LazyContentBlockAboutItem],
["ContentBlockAutomatedStock", LazyContentBlockAutomatedStock],
["ContentBlockAutomatedStockChart", LazyContentBlockAutomatedStockChart],
["ContentBlockBanner", LazyContentBlockBanner],
["ContentBlockCenteredText", LazyContentBlockCenteredText],
["ContentBlockCommitteeSection", LazyContentBlockCommitteeSection],
["ContentBlockContacts", LazyContentBlockContacts],
["ContentBlockCtaBanner", LazyContentBlockCtaBanner],
["ContentBlockDocuments", LazyContentBlockDocuments],
["ContentBlockEmbedDocument", LazyContentBlockEmbedDocument],
["ContentBlockEvents", LazyContentBlockEvents],
["ContentBlockEventsAlternative", LazyContentBlockEventsAlternative],
["ContentBlockFaqByTopics", LazyContentBlockFaqByTopics],
["ContentBlockFinancials", LazyContentBlockFinancials],
["ContentBlockHero", LazyContentBlockHero],
["ContentBlockHeroAlternative", LazyContentBlockHeroAlternative],
["ContentBlockImage", LazyContentBlockImage],
["ContentBlockImageWithList", LazyContentBlockImageWithList],
["ContentBlockImageWithListItem", LazyContentBlockImageWithListItem],
["ContentBlockKaleidoscopePressReleases", LazyContentBlockKaleidoscopePressReleases],
["ContentBlockLeadership", LazyContentBlockLeadership],
["ContentBlockLinks", LazyContentBlockLinks],
["ContentBlockNumbersList", LazyContentBlockNumbersList],
["ContentBlockNumbersListItem", LazyContentBlockNumbersListItem],
["ContentBlockPageTitle", LazyContentBlockPageTitle],
["ContentBlockParagraph", LazyContentBlockParagraph],
["ContentBlockPressReleases", LazyContentBlockPressReleases],
["ContentBlockPressReleasesAlternative", LazyContentBlockPressReleasesAlternative],
["ContentBlockPromoBanner", LazyContentBlockPromoBanner],
["ContentBlockQuote", LazyContentBlockQuote],
["ContentBlockReports", LazyContentBlockReports],
["ContentBlockResources", LazyContentBlockResources],
["ContentBlockResourcesAlternative", LazyContentBlockResourcesAlternative],
["ContentBlockShortBanner", LazyContentBlockShortBanner],
["ContentBlockStock", LazyContentBlockStock],
["ContentBlockTeamGrid", LazyContentBlockTeamGrid],
["ContentBlockTeamGridItem", LazyContentBlockTeamGridItem],
["ContentBlockTeamSlider", LazyContentBlockTeamSlider],
["ContentBlockTeamSliderItem", LazyContentBlockTeamSliderItem],
["ContentBlockTextWithImage", LazyContentBlockTextWithImage],
["ContentBlockTiles", LazyContentBlockTiles],
["ContentBlockTwoColumnsText", LazyContentBlockTwoColumnsText],
["ContentBlockVideosTimeline", LazyContentBlockVideosTimeline],
["ContentBlockVideosTimelineElement", LazyContentBlockVideosTimelineElement],
["Icon", LazyIcon],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
